import React, { memo, useCallback, useState } from 'react';
import { LayoutChangeEvent } from 'react-native';
import { Box, PressableIcon, Text, useSafeAreaInsets } from '@betty/moonlight';
import { RegistrationNavigationHeaderProps } from './RegistrationNavigationHeader.types';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import { selectRegistrationStepIndex, setStepIndex } from '../../../state';
import { BottomSheet } from '@betty/navigation';

function RegistrationNavigationHeader({
  options,
}: RegistrationNavigationHeaderProps) {
  const dispatch = useDispatch();
  const { top, left } = useSafeAreaInsets();
  const [leftWidth, setLeftWidth] = useState(0);
  const [rightWidth, setRightWidth] = useState(0);
  const stepIndex = useSelector(selectRegistrationStepIndex);

  const onLeftLayout = useCallback((e: LayoutChangeEvent) => {
    setLeftWidth(e.nativeEvent.layout.width);
  }, []);

  const onRightLayout = useCallback((e: LayoutChangeEvent) => {
    setRightWidth(e.nativeEvent.layout.width);
  }, []);

  const returnToPreviousStep = useCallback(() => {
    if (stepIndex !== 0) {
      const previousStepIndex = stepIndex - 1;
      dispatch(setStepIndex(previousStepIndex));
    } else {
      BottomSheet.open({
        namespace: 'registration',
        type: 'QuitRegistrationBottomSheet',
      });
    }
  }, [stepIndex, dispatch]);

  const closeRegistration = useCallback(() => {
    BottomSheet.open({
      namespace: 'registration',
      type: 'QuitRegistrationBottomSheet',
    });
  }, []);

  return (
    <Box flexDirection="row">
      <Box width={left} />
      <Box flex={1}>
        <Box height={top || 'space-200'} />
        <Box
          position="relative"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          gap="space-100"
          paddingHorizontal="space-100"
        >
          <Box
            absoluteFill
            centerContent
            paddingLeft={leftWidth}
            paddingRight={rightWidth}
          >
            <Text variant="body-m-semi" gradient="darkSurfaceAccent">
              {options.title}
            </Text>
          </Box>
          <Box onLayout={onLeftLayout}>
            <PressableIcon
              padding="space-100"
              gradient="accentBackground"
              name="arrowBackOutlined"
              onPress={returnToPreviousStep}
            />
          </Box>
          <Box
            flexDirection="row"
            alignItems="center"
            gap="space-100"
            onLayout={onRightLayout}
          >
            <PressableIcon
              name="close"
              width="space-800"
              height="space-800"
              padding="space-100"
              gradient="accentBackground"
              onPress={closeRegistration}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default memo(RegistrationNavigationHeader);
